import { useContext } from 'react'

import { FormControlLabel, Switch } from '@material-ui/core'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES } from '../../components/constants'

const fieldName = FIELD_NAMES.IS_HIDDEN

const HiddenSwitch = () => {
  const { item, onUpdateField } = useContext(ContentModalContext)

  const value = item[fieldName]

  return (
    <FormControlLabel
      control={
        <Switch
          checked={!value}
          onChange={(e) => {
            onUpdateField(fieldName, !e.target.checked)
          }}
          name="IsHidden"
          color="primary"
        />
      }
      label={value ? 'Hidden' : 'Live'}
    />
  )
}

export default HiddenSwitch
